import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import RateReviewIcon from '@mui/icons-material/RateReview';
import EditNoteIcon from '@mui/icons-material/EditNote';

function ExtraLoadingSaleIndex() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const { id } = useParams(); // trip id 
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [isFocused, setIsFocused] = useState(false);
   
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('TripInvoiceApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [searchQuery, setSearchQuery] = useState('');
  
    // Handle search input
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    // Filter data based on search query
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        setData([]); // Clear the existing data with an empty array

        try {
            const response = await fetchData('TripInvoiceApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6" style={{ maxWidth: '90%' }}>
        <div className='w-full mb-1 flex' style={{ marginTop: '-10px', marginLeft: '10px' }}>
            <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                EXTRA LOADING SALE</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '300px' : '200px',
                        height: '40px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginTop: '20px'
                    }}
                />
                </div>
                {/* Search field */}
                <div className="w-1/4 mr-2" style={{ marginTop: '-10px' }}>

                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                        Trip
                    </label>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                        isSearchable
                    />
                </div>

            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#243642' }}>
                            <TableRow>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '50px' }}>Order.No</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Cus.Order No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left' }}>Customer</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>OrderDate</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>No:Of Product</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Action</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#FEF9F2' }}>
                {filteredData.length > 0 ? (
                    filteredData.map((item) => (
                        <TableRow key={item.id} className="size">
                            <TableCell
                                sx={{
                                    borderBottom: '1px solid #F5F5F5',
                                    color: 'black',
                                    padding: '2px',
                                    textAlign: 'center',
                                }}
                            >
                                {item.routeseqNo}
                            </TableCell>
                            <TableCell
                                sx={{
                                    borderBottom: '1px solid #F5F5F5',
                                    color: 'black',
                                    padding: '2px',
                                    textAlign: 'left',
                                }}
                            >
                                <h6
                                    className="psheading linkcolor"
                                    style={{
                                        
                                        color: 'black',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {item.customerName} {item.addressLine1}
                                </h6>
                            </TableCell>
                            <TableCell
                                sx={{
                                    borderBottom: '1px solid #F5F5F5',
                                    color: 'black',
                                    padding: '2px',
                                  
                                }}
                            >
                                {item.phone}
                            </TableCell>
                            <TableCell
                                sx={{
                                    borderBottom: '1px solid #F5F5F5',
                                    color: 'orangered',
                                   
                                    padding: '2px',
                                }}
                            >
                                {item.orderDate && new Date(item.orderDate).toLocaleDateString('en-GB')}                                                                                   
                            </TableCell>
                            <TableCell
                                sx={{
                                    borderBottom: '1px solid #F5F5F5',
                                    color: 'darkblue',
                                   
                                    padding: '2px',
                                    textAlign: 'center'
                                }}
                            >
                                {item.itemcount}
                            </TableCell>
                            <TableCell
                                sx={{
                                    borderBottom: '1px solid #F5F5F5',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    padding: '2px',
                                }}
                            >
                                {item.isClosedRouteEdit === 1 ? (
                                    <Tooltip title="Edit the Saled Items">
                                        <Link to={`/ExtraSaleOrderEdit/${item.id}`}>
                                            <IconButton style={{ height: '40px' }}>
                                                <EditIcon style={{ color: 'brown' }} />
                                            </IconButton>
                                        </Link>
                                    </Tooltip>
                                ) : item.isClosedRouteEdit === 2 ? (
                                    <Tooltip title="Edit Sale Order">
                                        <Link to={`/SaleExtraOrderEdit/${item.id}`}>
                                            <IconButton style={{ height: '40px' }}>
                                                <EditNoteIcon style={{ color: 'darkgoldenrod', fontWeight: 'bold' }} />
                                            </IconButton>
                                        </Link>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Create Sale Order">
                                        <Link to={`/ExtraSaleOrderCreate/${item.customerId}/${item.tripId}`}>
                                            <IconButton style={{ height: '40px' }}>
                                                <RateReviewIcon style={{ color: 'darksalmon', fontWeight: 'bold' }} />
                                            </IconButton>
                                        </Link>
                                    </Tooltip>
                                )}
                            </TableCell>
                        </TableRow>
                    ))
                ) : (
                    <TableRow>
                        <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                            No data available
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>

                    </Table>
                </TableContainer>
            </div>

        </div>
    );
}
export default ExtraLoadingSaleIndex;

